const Main = (resolve) => require(["@/components/main/Main.vue"], resolve);
const Main1 = (resolve) => require(["@/components/main/Main1.vue"], resolve);
const shopMain = (resolve) =>
  require(["@/components/main/shopMain.vue"], resolve);

const productMain = (resolve) =>
  require(["@/module/quickorder/productMain.vue"], resolve);

//主页
const Home = (resolve) => require(["@/module/home/Home.vue"], resolve);
const Home1 = (resolve) => require(["@/module/home/home1.vue"], resolve);
const EditApply = (resolve) =>
  require(["@/module/home/editApply.vue"], resolve);

//消息
const Message = (resolve) =>
  require(["@/module/message/messageList.vue"], resolve);

//分类
const MenuList = (resolve) => require(["@/module/menu/MenuList.vue"], resolve);
//公告管理
const NoticeList = (resolve) =>
  require(["@/module/notice/noticeList.vue"], resolve);
const NoticeView = (resolve) =>
  require(["@/module/notice/noticeView.vue"], resolve);
// 订单收藏
const CollectView = (resolve) =>
  require(["@/module/collect/CollectView.vue"], resolve);
//订单管理
const ShipmentList = (resolve) =>
  require(["@/module/shipment/shipmentList.vue"], resolve);
const ShipmentView = (resolve) =>
  require(["@/module/shipment/shipmentView.vue"], resolve);
const InvoiceList = (resolve) =>
  require(["@/module/invoice/invoiceList.vue"], resolve);
const InvoiceView = (resolve) =>
  require(["@/module/invoice/invoiceView.vue"], resolve);
const BillingList = (resolve) =>
  require(["@/module/billing/billingList.vue"], resolve);
const BillingView = (resolve) =>
  require(["@/module/billing/billingView.vue"], resolve);
const ContractList = (resolve) =>
  require(["@/module/contract/ContractList.vue"], resolve);
const ContractView = (resolve) =>
  require(["@/module/contract/ContractView.vue"], resolve);

const SaleOrderList = (resolve) =>
  require(["@/module/order/saleorderList.vue"], resolve);
const SaleOrderView = (resolve) =>
  require(["@/module/order/saleorderView.vue"], resolve);

const ShoppingMallChooseProduct = (resolve) =>
  require(["@/module/quickorder/chooseProduct.vue"], resolve);
const ShoppingMallSearchProduct = (resolve) =>
  require(["@/module/quickorder/searchProduct.vue"], resolve);
const ProductDetail = (resolve) =>
  require(["@/module/quickorder/productDetail.vue"], resolve);
const OrderConfirm = (resolve) =>
  require(["@/module/quickorder/confirm.vue"], resolve);
const OrderComplete = (resolve) =>
  require(["@/module/quickorder/complete.vue"], resolve);
const ShoppingMallImportProduct = (resolve) =>
  require(["@/module/quickorder/importProduct.vue"], resolve);

const ForecastList = (resolve) =>
  require(["@/module/forecast/forecastList.vue"], resolve);
const ForecastView = (resolve) =>
  require(["@/module/forecast/forecastView.vue"], resolve);

const FileDownloadList = (resolve) =>
  require(["@/module/filedownload/filedownloadList.vue"], resolve);
const FileDownloadView = (resolve) =>
  require(["@/module/filedownload/filedownloadView.vue"], resolve);
const ForcecastReport = (resolve) =>
  require(["@/module/forecast/forcecastReport.vue"], resolve);

const SalesmanList = (resolve) =>
  require(["@/module/salesman/salesmanList.vue"], resolve);
const SalesmanView = (resolve) =>
  require(["@/module/salesman/salesmanView.vue"], resolve);
const SalesmanEdit = (resolve) =>
  require(["@/module/salesman/salesmanEdit.vue"], resolve);

const CreateOpportunity = (resolve) =>
  require(["@/module/opportunity/createOpportunity.vue"], resolve);
const OpportunityList = (resolve) =>
  require(["@/module/opportunity/opportunityList.vue"], resolve);
const OpportunityEdit = (resolve) =>
  require(["@/module/opportunity/opportunityEdit.vue"], resolve);

//补件申请
const ResissueApplicationList = (resolve) =>
  require([
    "@/module/resissueapplication/resissueApplicationList.vue",
  ], resolve);
const ResissueApplicationDetail = (resolve) =>
  require([
    "@/module/resissueapplication/resissueApplicationDetail.vue",
  ], resolve);
const QuickOrderList = (resolve) =>
  require(["@/module/quickorder/quickOrderList.vue"], resolve);
const ProPriceList = (resolve) =>
  require(["@/module/proprice/propriceList.vue"], resolve);
const ProPriceView = (resolve) =>
  require(["@/module/proprice/propriceView.vue"], resolve);

//临时额度申请
const TempcreditList = (resolve) =>
  require(["@/module/tempcredit/tempcreditList.vue"], resolve);
const TempcreditView = (resolve) =>
  require(["@/module/tempcredit/tempcreditView.vue"], resolve);

//费用申请
const CostapplyList = (resolve) =>
  require(["@/module/costapply/costapplyList.vue"], resolve);
const CostapplyView = (resolve) =>
  require(["@/module/costapply/costapplyView.vue"], resolve);

//返利管理
const RebatedetailList = (resolve) =>
  require(["@/module/rebatedetail/rebatedetailList.vue"], resolve);

//财务管理   对账单
const AccountStatementList = (resolve) =>
  require(["@/module/accountstatement/accountstatementList.vue"], resolve);

const AccountStatementDetail = (resolve) =>
  require(["@/module/accountstatement/accountstatementDetail.vue"], resolve);
const ResetPasswordView = (resolve) =>
  require(["@/module/resetpassword/ResetPasswordView.vue"], resolve);
const ShoppingCartList = (resolve) =>
  require(["@/module/quickorder/shoppingCartList.vue"], resolve);

//报价单配置
const QuotationConfigList = (resolve) =>
  require(["@/module/quotationconfig/quotationConfigList.vue"], resolve);
const QuotationConfigDetail = (resolve) =>
  require(["@/module/quotationconfig/quotationConfigDetail.vue"], resolve);
const QuoteDetails = (resolve) =>
  require(["@/module/productCatalog/QuoteDetails.vue"], resolve);
const productCatalogIndex = (resolve) =>
  require(["@/module/productCatalog/productCatalogIndex.vue"], resolve);
const collectList = (resolve) =>
  require(["@/module/productCatalog/collectList.vue"], resolve);
const vehicleVarConfigList = (resolve) =>
  require(["@/module/productCatalog/vehicleVarConfigList.vue"], resolve);

// 家装公司
const homecompanyList = (resolve) =>
  require(["@/module/homecompany/homecompanyList.vue"], resolve);
const homecompanyView = (resolve) =>
  require(["@/module/homecompany/homecompanyView.vue"], resolve);
// 家装公司订单
const companyorderList = (resolve) =>
  require(["@/module/companyorder/companyorderList.vue"], resolve);
const companyorderView = (resolve) =>
  require(["@/module/companyorder/companyorderView.vue"], resolve);

// 设计师
const designerList = (resolve) =>
  require(["@/module/designer/designerList.vue"], resolve);
const designerView = (resolve) =>
  require(["@/module/designer/designerView.vue"], resolve);

  // 订单集
const orderpackageList = (resolve) =>
require(["@/module/orderpackage/orderpackageList.vue"], resolve);
const orderpackageView = (resolve) =>
require(["@/module/orderpackage/orderpackageView.vue"], resolve);
const orderView = (resolve) =>
require(["@/module/orderpackage/orderView.vue"], resolve);
const orderdetailView = (resolve) =>
require(["@/module/orderpackage/orderdetailView.vue"], resolve);
const orderlist = (resolve) =>
require(["@/module/orderpackage/orderlist.vue"], resolve);

//经销商人员档案
const accountstaffList = (resolve)=>
require(["@/module/accountstaff/accountstaffList.vue"],resolve);
const accountstaffView = (resolve)=>
require(["@/module/accountstaff/accountstaffView.vue"],resolve);

  //设计师订单
const designerorderList = (resolve) =>
  require(["@/module/designerorder/designerorderList.vue"], resolve);
const designerorderView = (resolve) =>
  require(["@/module/designerorder/designerorderView.vue"], resolve);
  //设计师订单报表
  const designerorderreport = (resolve) =>
  require(["@/module/report/designerorderreport.vue"], resolve);
    //设计师订单报表
const designerinforeport = (resolve) =>
  require(["@/module/report/designerinforeport.vue"], resolve);
  const designerorderinforeport = (resolve) =>
  require(["@/module/report/designerorderInforeport.vue"], resolve);
  //战略价格申请
  const priceapplyList = (resolve) =>
  require(["@/module/priceapply/priceapplyList.vue"], resolve);
  const priceapplyView = (resolve) =>
  require(["@/module/priceapply/priceapplyView.vue"], resolve);

export default [
  {
    path: "/",
    component: Home,
    children: [
      {
        path: "/",
        name: "home",
        meta: {
          keepAlive: true,
          allowAnonymous: true,
        },
        component: Home,
      },
    ],
  },
  {
    path: "/home1",
    component: getViews("Main"),
    children: [
      {
        path: "/home1",
        name: "home1",
        component: Home1,
      },
    ],
  },
  {
    path: "/edit",
    component: getViews("Main"),
    children: [
      {
        path: "apply",
        name: "editApply",
        component: EditApply,
      },
    ],
  },
  {
    path: "/message",
    component: getViews("Main"),
    children: [
      {
        path: "message",
        name: "message",
        meta: {
          keepAlive: true,
        },
        component: Message,
      },
    ],
  },
  {
    path: "/menu",
    component: getProductViews("productMain"),
    children: [
      {
        path: "menulist",
        name: "menu-list",
        meta: {
          allowAnonymous: true,
        },
        component: MenuList,
      },
    ],
  },
  {
    path: "/notice",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "NoticeList",
        component: NoticeList,
      },
      {
        path: "view/:id",
        name: "notice-detail",
        component: NoticeView,
      },
    ],
  },
  {
    path: "/shoppingmall",
    component: getProductViews("productMain"),
    children: [
      {
        path: "chooseproduct/:name?/:id?",
        name: "ShoppingMallChooseProduct",
        meta: {
          allowAnonymous: true,
        },
        component: ShoppingMallChooseProduct,
      },
      {
        path: "searchproduct/:name?",
        name: "ShoppingMallSearchProduct",
        meta: {
          allowAnonymous: true,
        },
        component: ShoppingMallSearchProduct,
      },
      {
        path: "productdetail",
        name: "product-detail",
        meta: {
          allowAnonymous: true,
        },
        component: ProductDetail,
      },
    ],
  },
  {
    path: "/collect",
    component: getViews("Main"),
    children: [
      {
        path: "view",
        name: "collect-view",
        component: CollectView,
      },
    ],
  },

  {
    path: "/shipment",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "ShipmentList",
        component: ShipmentList,
      },
      {
        path: "view/:id",
        name: "ShipmentView",
        component: ShipmentView,
      },
    ],
  },
  {
    path: "/invoice",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "InvoiceList",
        component: InvoiceList,
      },
      {
        path: "view/:id",
        name: "InvoiceView",
        component: InvoiceView,
      },
    ],
  },
  {
    path: "/billing",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "BillingList",
        component: BillingList,
      },
      {
        path: "view/:id",
        name: "BillingView",
        component: BillingView,
      },
    ],
  },
  {
    path: "/order",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "SaleOrderList",
        component: SaleOrderList,
      },
      {
        path: ":id/:name/:time/complete",
        name: "OrderComplete",
        component: OrderComplete,
      },
      {
        path: ":id/detail",
        name: "order-detail",
        component: SaleOrderView,
      },
    ],
  },
  {
    path: "/shopcart",
    component: getViews("shopMain"),
    children: [
      {
        path: "list",
        name: "ShoppingCartList",
        component: ShoppingCartList,
      },
    ],
  },
  {
    path: "/confirm",
    component: getProductViews("OrderConfirm"),
    children: [
      {
        path: ":id/order",
        name: "OrderConfirm",
        component: OrderConfirm,
      },
    ],
  },
  {
    path: "/quickorder",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "QuickOrderList",
        component: QuickOrderList,
      },
      ,
      {
        path: "importproduct",
        meta: {
          keepAlive: true,
          allowAnonymous: true,
        },
        component: ShoppingMallImportProduct,
      },
    ],
  },
  {
    path: "/contract",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "ContractList",
        component: ContractList,
      },
      {
        path: "view/:id",
        name: "ContractView",
        component: ContractView,
      },
    ],
  },
  {
    path: "/proprice",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "ProPriceList",
        component: ProPriceList,
      },
      {
        path: "create",
        name: "ProPriceCreate",
        component: ProPriceView,
      },
      {
        path: "view/:id",
        name: "proprice-detail",
        component: ProPriceView,
      },
    ],
  },
  {
    path: "/salesforecast",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "ForecastList",
        component: ForecastList,
      },
      {
        path: "view/:id",
        name: "ForecastView",
        component: ForecastView,
      },
      {
        path: "create",
        name: "ForecastCreate",
        component: ForecastView,
      },
      {
        path: "report",
        name: "ForcecastReport",
        component: ForcecastReport,
      },
    ],
  },
  {
    path: "/filedownload",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "FileDownloadList",
        component: FileDownloadList,
      },
      {
        path: "view/:id",
        name: "FileDownloadView",
        component: FileDownloadView,
      },
    ],
  },
  {
    path: "/salesman",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "SalesmanList",
        component: SalesmanList,
      },
      {
        path: "Edit/:id",
        name: "SalesmanEdit",
        component: SalesmanEdit,
      },
      {
        path: "view",
        name: "SalesmanView",
        component: SalesmanView,
      },
    ],
  },
  {
    path: "/opportunity",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "OpportunityList",
        component: OpportunityList,
      },
      {
        path: "edit/:id",
        name: "OpportunityEdit",
        component: OpportunityEdit,
      },
      {
        path: "create",
        name: "CreateOpportunity",
        component: CreateOpportunity,
      },
    ],
  },
  {
    path: "/resissueapplication",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "ResissueApplicationList",
        component: ResissueApplicationList,
      },
      {
        path: "detail/:id",
        name: "ResissueApplicationDetail",
        component: ResissueApplicationDetail,
      },
    ],
  },
  {
    path: "/tempcredit",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "TempcreditList",
        component: TempcreditList,
      },
      {
        path: "view/:id",
        name: "tempcredit-detail",
        component: TempcreditView,
      },
      {
        path: "create",
        name: "TempcreditCreate",
        component: TempcreditView,
      },
    ],
  },
  {
    path: "/costapply",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "CostapplyList",
        component: CostapplyList,
      },
      {
        path: "view/:id",
        name: "costapply-detail",
        component: CostapplyView,
      },
      {
        path: "create",
        name: "CostapplyCreate",
        component: CostapplyView,
      },
    ],
  },
  {
    path: "/rebatedetail",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "RebatedetailList",
        component: RebatedetailList,
      },
    ],
  },
  {
    path: "/accountstatementlist",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "accountstatementList",
        component: AccountStatementList,
      },
    ],
  },
  {
    path: "/accountstatementDetail/:id/:date",
    component: getViews("Main"),
    children: [
      {
        path: "detail",
        name: "accountstatement-detail",
        component: AccountStatementDetail,
      },
    ],
  },
  {
    path: "/resetpassword",
    component: getViews("Main"),
    children: [
      {
        path: "view",
        name: "resetpassword-view",
        component: ResetPasswordView,
      },
    ],
  },
  //配置报价
  {
    path: "/quotationconfig/list",
    name: "quotationconfiglist",
    meta: {
      allowAnonymous: true,
    },
    component: QuotationConfigList,
  },
  {
    path: "/quotationconfig/create/:quoteId?",
    name: "quotationconfigcreate",
    meta: {
      allowAnonymous: true,
    },
    component: QuotationConfigDetail,
  },
  {
    path: "/quotationconfig/edit/:quoteId?/:cpqQuoteId?",
    name: "quotationconfigedit",
    meta: {
      allowAnonymous: true,
    },
    component: QuotationConfigDetail,
  },
  {
    path: "/quote/details/:cpqQuoteId?",
    name: "quotedetails",
    meta: {
      allowAnonymous: true,
    },
    component: QuoteDetails,
  },
  {
    path: "/product/catalog",
    name: "productcatalog",
    meta: {
      allowAnonymous: true,
    },
    component: productCatalogIndex,
  },
  {
    path: "/collect/list",
    name: "collectlist",
    meta: {
      allowAnonymous: true,
    },
    component: collectList,
  },
  {
    path: "/config/page",
    name: "configpage",
    meta: {
      allowAnonymous: true,
    },
    component: vehicleVarConfigList,
  },
  {
    path: "/homecompany",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "homecompanyList",
        component: homecompanyList,
      },
      {
        path: "create",
        name: "HomeCompanyCreate",
        component: homecompanyView,
      },
      {
        path: "view/:id",
        name: "homecompany-detail",
        component: homecompanyView,
      }
    ],
  },
  //战略价格路径
  {
    path: "/priceapply",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "priceapplyList",
        component: priceapplyList,
      },
      {
        path: "view/:id",
        name: "priceapply-detail",
        component: priceapplyView,
      },
    ],
  },
  {
    path: "/companyorder",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "companyorderList",
        component: companyorderList,
      },
      {
        path: "create",
        name: "companyOrderCreate",
        component: companyorderView,
      },
      {
        path: "view/:id",
        name: "companyorder-detail",
        component: companyorderView,
      }
    ],
  },
  {
    path: "/orderpackage",
    component: getViews("Main"),
    children:[
      {
        path: "list",
        name: "orderpackageList",
        component:orderpackageList,
      },
      {
        path: "view/:id",
        name: "orderpackageView",
        component:orderpackageView,
      },
      {
        path:"order/:id/:issubmit?",
        name:"orderview",
        component:orderView,
      },
      {
        path:"create/:packageid",
        name:"ordercreate",
        component:orderView,
      },
      {
        path:"detail/:id",
        name:"ordetailview",
        component:orderdetailView,
      },
      {
        path:"create/:orderid",
        name:"ordetailcreate",
        component:orderdetailView,
      },
      {
        path:"orderlist",
        name:"orderlist",
        component:orderlist,
      },
    ]
  },
  {
    path: "/accountstaff",
    component: getViews("Main"),
    children:[
      {
        path: "list",
        name: "accountstaffList",
        component:accountstaffList,
      },
      {
        path: "view/:id",
        name: "accountstaffView",
        component:accountstaffView,
      }
    ]
  },
  {
    path: "/designer",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "designerList",
        component: designerList,
      },
      {
        path: "create/:phone",
        name: "designerCreate",
        component: designerView,
      },
      {
        path: "view/:id",
        name: "designer-detail",
        component: designerView,
      }
    ],
  },
  {
    path: "/designerorder",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "designerorderList",
        component: designerorderList,
      },
      {
        path: "create/:phone",
        name: "designerorderCreate",
        component: designerorderView,
      },
      {
        path: "view/:id",
        name: "designerorder-detail",
        component: designerorderView,
      }
    ],
  },
  {
    path: "/report",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "designerorderreport",
        component: designerorderreport,
      },
      {
        path: "designerinfolist",
        name: "designerinforeport",
        component: designerinforeport,
      },
      {
        path: "designerorderinfolist",
        name: "designerorderinforeport",
        component: designerorderinforeport,
      }
    ],
  }
];
import store from "../store";

function getViews(path) {
  const isStore = store.state.isStore;
  if (isStore) {
    return (resolve) =>
      require(["@/components/main/" + path + ".vue"], resolve);
  } else {
    return (resolve) => require(["@/components/main/Main1.vue"], resolve);
  }
}

function getProductViews(path) {
  const isStore = store.state.isStore;
  if (isStore) {
    return (resolve) =>
      require(["@/module/quickorder/" + path + ".vue"], resolve);
  } else {
    return (resolve) => require(["@/components/main/Main1.vue"], resolve);
  }
}



// WEBPACK FOOTER //
// ./src/module/router.js